import React from "react";
import {
  Eye,
  Sparkles,
  Lock,
  Wind,
  Shield,
  Plus,
  Building2,
  Home,
  Minus,
  Brain,
  Moon,
  Activity,
  Check,
  ShieldCheck,
} from "lucide-react";
import { FormError } from "../../../../common/Input";

interface Props {
  register: any;
  errors: any;
  setValue: any;
  watch: any;
}

const motifsConsultation = [
  { key: "mauvais_oeil", label: "Mauvais œil", icon: Eye },
  { key: "sorcellerie", label: "Sorcellerie", icon: Sparkles },
  { key: "blocage", label: "Blocage", icon: Lock },
  { key: "djinn", label: "Djinn", icon: Wind },
  { key: "protection", label: "Protection", icon: Shield },
  { key: "autre", label: "Autre", icon: Plus },
];

const typesConsultation = [
  { key: "cabinet", label: "Au cabinet", icon: Building2 },
  { key: "domicile", label: "À domicile", icon: Home },
  { key: "distance", label: "À distance", icon: Minus },
];

const symptomes = [
  { key: "etat_mental_anormal", label: "État mental anormal", icon: Brain },
  { key: "blocages", label: "Blocages", icon: Lock },
  { key: "cauchemars", label: "Cauchemars", icon: Moon },
  { key: "probleme_sante_anormal", label: "Problème santé anormal", icon: Activity },
];

function OptionCard({
  label,
  Icon,
  selected,
  onClick,
  inputType,
}: {
  label: string;
  Icon: React.ComponentType<any>;
  selected: boolean;
  onClick: () => void;
  inputType: "checkbox" | "radio";
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`im-card ${selected ? "im-card--selected" : ""}`}
    >
      <span className="im-card__left">
        <span className={`im-icon-circle ${selected ? "im-icon-circle--selected" : ""}`}>
          <Icon size={16} strokeWidth={2.2} />
        </span>
        <span className="im-card__label">{label}</span>
      </span>

      <span
        className={`im-checkbox im-checkbox--${inputType} ${
          selected ? "im-checkbox--selected" : ""
        }`}
      >
        {selected && <Check size={12} className="im-checkbox__icon" strokeWidth={3} />}
      </span>
    </button>
  );
}

function InformationsMedicales({ register, errors, setValue, watch }: Props) {
  const typeConsultation = watch ? watch("type_consultation") : undefined;
  const motifs = watch ? watch("motifs_consultation") || [] : [];
  const symptomesChecked = watch ? watch("symptomes") || [] : [];

  const toggleInArray = (field: string, value: string, current: string[]) => {
    const next = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    setValue(field, next);
  };

  return (
    <div className="form-register-tabs-component im-card-container mt-5">
      <p className="im-title mb-1">Informations médicales</p>
      <p className="im-subtitle">
        Veuillez vérifier vos choix et passer à l'étape de paiement.
      </p>

      <div className="im-banner mb-4">
        <ShieldCheck size={18} className="im-banner__icon" />
        <span className="im-banner__text">
          Toutes vos informations sont sécurisées et restent confidentielles.
        </span>
      </div>

      <div className="infos_livraison_container">
        <p className="fw-semibold mb-1">Motif de consultation</p>
        <p className="im-label-muted small mb-2">
          Sélectionnez un ou plusieurs motifs (facultatif)
        </p>
        <div className="row mb-4 g-3">
          {motifsConsultation.map((m) => (
            <div className="col-md-4" key={m.key}>
              <OptionCard
                label={m.label}
                Icon={m.icon}
                selected={motifs.includes(m.key)}
                inputType="checkbox"
                onClick={() => toggleInArray("motifs_consultation", m.key, motifs)}
              />
            </div>
          ))}
        </div>

        <p className="fw-semibold mb-1">Type de consultation</p>
        <p className="im-label-muted small mb-2">
          Choisissez le type de consultation souhaité
        </p>
        <div className="row mb-4 g-3">
          {typesConsultation.map((t) => (
            <div className="col-md-4" key={t.key}>
              <OptionCard
                label={t.label}
                Icon={t.icon}
                selected={typeConsultation === t.key}
                inputType="radio"
                onClick={() => setValue("type_consultation", t.key)}
              />
            </div>
          ))}
        </div>
        <FormError error={errors?.type_consultation?.message} />

        <p className="fw-semibold mb-1">Symptômes</p>
        <p className="im-label-muted small mb-2">
          Sélectionnez un ou plusieurs symptômes (facultatif)
        </p>
        <div className="row mb-4 g-3">
          {symptomes.map((s) => (
            <div className="col-md-4" key={s.key}>
              <OptionCard
                label={s.label}
                Icon={s.icon}
                selected={symptomesChecked.includes(s.key)}
                inputType="checkbox"
                onClick={() => toggleInArray("symptomes", s.key, symptomesChecked)}
              />
            </div>
          ))}
        </div>

        <div className="col-md-7 mb-3">
          <p className="fw-semibold mb-2">Motif du rendez-vous</p>
          <div className="im-textarea-wrap">
            <label htmlFor="motif_rendez_vous" className="im-textarea-label">
              Motif
            </label>
            <textarea
              id="motif_rendez_vous"
              className="form-control im-textarea"
              placeholder="Votre réponse..."
              cols={30}
              rows={2}
              {...register("motif_rendez_vous")}
            ></textarea>
          </div>
          <FormError error={errors?.motif_rendez_vous?.message} />
        </div>
      </div>
    </div>
  );
}

export default InformationsMedicales;